<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6LvgY/tc-custom/9781942266075.jpg?1737197408017" alt="This image is the cover for the book Dixie's Last Stand"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dixie's Last Stand
      </h1>
      <p class="bookDescription body article font2">
        <b>The true crime author of <i>Body of Proof</i> investigates the case of an Iowa woman charged with murder for killing her abusive husband.</b><br/>  <br/> Scott and Dixie Shanahan lived in a gray ranch along Third Avenue in the sleepy Midwestern town of Defiance, Iowa. With a population of less than 400, everyone in Defiance knew the home for its recurring episodes of screaming, mayhem, and horrific domestic violence.<br/><br/> Then one day, Scott Shanahan was gone. Some thought the abusive husband had packed his bags and left town. After months went by with still no sign of the volatile wife beater, people began to ask questions. But what really happened to him was so shocking that even long-time law enforcement officials were aghast by the sight and awful smell. When Dixie was arrested for Scott’s murder, she made a credible claim of self-defense. But how did she manage to live with her husband’s rotting body inside her master bedroom for fourteen months?<br/>  <br/> In <i>Dixie’s Last Stand</i>, investigative journalist John Ferak explores a tragic tale of marital abuse to ask: did Dixie Shanahan deserve to be convicted of murder?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ferak
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b546a356